import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: 800,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.modal__background_primary,
    padding: theme.spacing(12),
    gap: theme.spacing(4)
  },
  title: {
    color: theme.colorPalette.green_75,
    fontSize: 40,
    lineHeight: '56px',
    fontWeight: 300,
    padding: 0,
    width: '100%'
  },
  text: {
    color: theme.colors.green_80,
    marginTop: 0,
    fontWeight: 400
  },
  list: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    padding: theme.spacing(0),
    gap: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: theme.colors.green_80
  },
  paragraph: {
    margin: theme.spacing(0)
  },
  detailsContent: {
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column'
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  card: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(4),
    alignSelf: 'stretch'
  },
  btnContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center'
  },
  btn: {
    padding: theme.spacing(1, 4)
  },
  notificationCardText: {
    fontSize: 12,
    padding: theme.spacing(0)
  },
  notification: {
    margin: theme.spacing(4, 0, 0),
    padding: theme.spacing(5, 4, 4),
    boxShadow: 'none',
    textAlign: 'start'
  },
  link: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline !important'
  }
}));

export default useStyles;
